import RushFeaturesPage from '../landing/rush/RushFeaturesPage';

const FeaturesPageWrapper = () => <RushFeaturesPage />;

export default FeaturesPageWrapper;
